import { render, staticRenderFns } from "./myClass.vue?vue&type=template&id=6544dfe9&scoped=true"
import script from "./myClass.vue?vue&type=script&lang=js"
export * from "./myClass.vue?vue&type=script&lang=js"
import style0 from "./myClass.vue?vue&type=style&index=0&id=6544dfe9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6544dfe9",
  null
  
)

export default component.exports